import { useCallback, useEffect, useState } from 'react';
import connectedMP3 from '../../sounds/connect.mp3';
import disconnectedMP3 from '../../sounds/disconnect.mp3';

export const useSounds = () => {
    const [connectedSound, setConnectedSound ] = useState(null);
    const [disconnectedSound, setDisconnectedSound] = useState(null);
    useEffect(() => {
        setConnectedSound(new Audio(connectedMP3));
        setDisconnectedSound(new Audio(disconnectedMP3));
    }, []);

    const playConnect = useCallback(() => {
        connectedSound && connectedSound.play();
    }, [connectedSound]);

    const playDisconnect = useCallback(() => {
        disconnectedSound && disconnectedSound.play();
    }, [disconnectedSound]);

    return {
        playConnect,
        playDisconnect
    }
}
